// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lawyer-profiles-container {
    padding: 20px;
  }
  
  .lawyer-profiles-container h2 {
    margin-bottom: 20px;
  }
  
  .lawyer-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .lawyer-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
  }
  
  .lawyer-info {
    flex: 1 1;
  }
  
  .lawyer-name {
    font-weight: bold;
  }
  
  .client-name, .event-name {
    font-size: 0.9em;
    color: #666;
  }
  
  .btn.upload {
    background-color: #007bff;
    color: white;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/lawyerprofile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB","sourcesContent":[".lawyer-profiles-container {\n    padding: 20px;\n  }\n  \n  .lawyer-profiles-container h2 {\n    margin-bottom: 20px;\n  }\n  \n  .lawyer-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .lawyer-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 8px;\n  }\n  \n  .lawyer-info {\n    flex: 1;\n  }\n  \n  .lawyer-name {\n    font-weight: bold;\n  }\n  \n  .client-name, .event-name {\n    font-size: 0.9em;\n    color: #666;\n  }\n  \n  .btn.upload {\n    background-color: #007bff;\n    color: white;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
